import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'

import * as styles from './HeroCarousel.module.css'

function NextArrow({ className, onClick }) {
  return (
    <div className="et-pb-slider-arrows">
      <button
        type="button"
        className={clsx(className, styles.arrow, 'et-pb-arrow-next')}
        onClick={onClick}
      >
        <span>Next</span>
      </button>
    </div>
  )
}

NextArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}

NextArrow.defaultProps = {
  className: null,
  onClick: () => {},
}

function PrevArrow({ className, onClick }) {
  return (
    <div className="et-pb-slider-arrows">
      <button
        type="button"
        className={clsx(className, styles.arrow, 'et-pb-arrow-prev')}
        onClick={onClick}
      >
        <span>Previous</span>
      </button>
    </div>
  )
}

PrevArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}

PrevArrow.defaultProps = {
  className: null,
  onClick: () => {},
}

function HeroCarousel({ children }) {
  return (
    <Slider
      fade
      autoplay
      speed={700}
      autoplaySpeed={7000}
      className="et_pb_slider et_pb_bg_layout_dark"
      nextArrow={<NextArrow />}
      prevArrow={<PrevArrow />}
    >
      {React.Children.map(children, (child) => (
        <div>{child}</div>
      ))}
    </Slider>
  )
}

HeroCarousel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
}

export default HeroCarousel
